import React, { useState, useEffect } from "react";
import worksCardEffect from "../../common/worksCardEffect";
import "../../css/Selection2.scss";

const HairClinicSelection = () => {
  useEffect(() => {
    worksCardEffect();
  }, []);

  // State to control overlay visibility
  const [overlayVisible, setOverlayVisible] = useState(true);
  const [hoveredTabs, setHoveredTabs] = useState({ tab1: false, tab2: false });

  // Function to handle hover interaction
  const handleHover = (tab) => {
    setHoveredTabs((prev) => ({ ...prev, [tab]: true }));

    // Hide overlay if both tabs have been hovered
    if (hoveredTabs.tab1 && hoveredTabs.tab2) {
      setOverlayVisible(false);
    }
  };

  return (
    <section
      className="portfolio full-bg"
      style={{
        height: "87vh",
      }}
    >
      <div className="container-fluid">
        {/* Hover Overlay - Centered for both images */}
        {/* {overlayVisible && (
          <div
            className="hover-overlay"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              color: "white",
              fontSize: "18px",
              padding: "20px",
              borderRadius: "10px",
              zIndex: 10,
            }}
          >
            Hover to navigate through renders
          </div>
        )} */}

        <div
          className="row"
          style={{ display: "flex", flexWrap: "wrap", width: "100%" }}
        >
          <div
            className="col-lg-6 col-md-6 cluom current"
            data-tab="tab-1"
            style={{ width: "50%", cursor: "pointer", position: "relative" }}
            onMouseEnter={() => handleHover("tab1")}
          >
            <div className="info" style={{ opacity: "0" }}></div>
            <div className="more"></div>
          </div>

          <div
            className="col-lg-6 col-md-6 cluom"
            data-tab="tab-2"
            style={{ width: "50%", cursor: "pointer", position: "relative" }}
            onMouseEnter={() => handleHover("tab2")}
          >
            <div className="info" style={{ opacity: "0" }}></div>
            <div className="more"></div>
          </div>

          {/* Left and Right Arrows */}
          <div
            className="divider-arrows"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 15,
              pointerEvents: "none", // Ensures arrows don't interfere with hover events
            }}
          >
            <div
              style={{
                position: "absolute",
                left: "-20px",
                width: "0",
                height: "0",
                borderTop: "10px solid transparent",
                borderBottom: "10px solid transparent",
                borderRight: "10px solid #e7e7e7",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                right: "-20px",
                width: "0",
                height: "0",
                borderTop: "10px solid transparent",
                borderBottom: "10px solid transparent",
                borderLeft: "10px solid #e7e7e7",
              }}
            ></div>
          </div>
        </div>
      </div>

      <div className="glry-img">
        <div
          id="tab-1"
          className="bg-img tab-img current"
          style={{
            backgroundImage: `url(../../Images/CommercialImages/15-HairClinic/6.jpg)`,
          }}
          data-overlay-dark="2"
        ></div>
        <div
          id="tab-2"
          className="bg-img tab-img"
          style={{
            backgroundImage: `url(../../Images/CommercialImages/15-HairClinic/7b.jpg)`,
          }}
          data-overlay-dark="2"
        ></div>
      </div>
    </section>
  );
};

export default HairClinicSelection;
